import { LocationScope, MergedLocationVar, LocationVarInheritance, LocationVarKey } from '@swivl-mono/types';
import { StringHelper } from '@swivl-mono/helpers';

import { WorksheetComponentLabel } from '../Label/WorksheetComponent.Label';
import { useAutosave } from 'react-autosave';
import React, { useEffect } from 'react';
import './WorksheetComponent.scss';

interface Props {
  label?: string;
  variable: MergedLocationVar;
  className: string;
  type: LocationScope;
  controlType: 'input' | 'textarea' | 'password';
  isEditing: boolean;
  disableReverting?: boolean;
  saveVariable: (value: string) => void;
  shouldSaveCallback?: (value: string) => Promise<boolean>;
  customize(): void;
  deleteVariable(): void;
  isLoading: boolean;
}

export function WorksheetComponentText(props: Props) {
  const { label, type, variable, isEditing, disableReverting, saveVariable, deleteVariable } = props;

  const [value, setValue] = React.useState<string>(variable.value);

  useEffect(() => {
    setValue(variable.value);
  }, [variable.value]);

  useAutosave({
    data: value,
    onSave: async (v) => {
      if (v !== variable.value) {
        if (props.shouldSaveCallback) {
          const shouldSave = await props.shouldSaveCallback(v);
          if (!shouldSave) {
            setValue(variable.value);
            return;
          }
        }
        saveVariable(v);
      }
    }
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newValue = event.target.value.replace(/\r?\n/g, '\\n');
    setValue(newValue);
  };

  return (
    <div
      className={`WorksheetComponent WorksheetComponentText
        ${props.className} ${isEditing ? 'isEditing' : ''} inheritance_${variable.inheritance}
        control_${props.controlType}
      `}
    >
      <WorksheetComponentLabel key={variable.inheritance + variable.key + variable.id} text={label} inheritance={variable.inheritance} isEditing={isEditing} type={type} canRevert={!disableReverting} isLoading={props.isLoading} deleteVariable={deleteVariable} />
      {isEditing ? (
        variable.inheritance === LocationVarInheritance.NONE ? (
          props.controlType === 'input' ? (
            <input value={value || ''} onChange={handleChange} />
          ) : props.controlType === 'password' ? (
            <input value={value || ''} onChange={handleChange} type="password" />
          ) : (
            <textarea value={value.replace(/\\n/g, '\n') || ''} onChange={handleChange} />
          )
        ) : (
          <div className="parentText" onClick={props.customize}>
            {value}
            <div className="parentTextOverlay">Click to Customize</div>
          </div>
        )
      ) : props.controlType === 'password' ? (
        <div className="valueText whitespace-pre-wrap">{StringHelper.replaceNewLineWithLineBreak('•'.repeat(value.length))}</div>
      ) : (
        <div className="valueText whitespace-pre-wrap">{StringHelper.replaceNewLineWithLineBreak(value)}</div>
      )}
    </div>
  );
}
